var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', {
    attrs: {
      "value": _vm.DELIVERY.value
    }
  }, [_c('div', {
    staticClass: "page-section-wrap"
  }, [_c('section', {
    staticClass: "page-section"
  }, [_c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "3"
    }
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("픽업 및 배송")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "9"
    }
  }, [_c('div', [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("직접 픽업")])]), _c('ul', {
    staticClass: "letter-list"
  }, [_c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("운송 주선 : 낙찰자 직접 작품 수령이 어려울 경우, 당사는 낙찰자의 책임과 비용 부담 하에, 미술품 운송 업체를 주선해드립니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("운송 주체 : 운송일정 및 장소, 비용 등의 세부적인 내용은 낙찰자가 운송업체와 직접 협의하시면 됩니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("택배 업체 : 작품 파손, 분실의 위험이 크므로 택배업체는 주선하지 않습니다.")])])])]), _c('div', {
    staticClass: "mt-18 mt-md-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("운송 주선")])]), _c('ul', {
    staticClass: "letter-list"
  }, [_c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("운송 주선 : 낙찰자 직접 작품 수령이 어려울 경우, 당사는 낙찰자의 책임과 비용 부담 하에, 미술품 운송 업체를 주선해드립니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("운송 주체 : 운송일정 및 장소, 비용 등의 세부적인 내용은 낙찰자가 운송업체와 직접 협의하시면 됩니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("택배 업체 : 작품 파손, 분실의 위험이 크므로 택배업체는 주선하지 않습니다.")])])])]), _c('div', {
    staticClass: "mt-18 mt-md-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("보관 비용")])]), _c('p', {
    staticClass: "page-text"
  }, [_vm._v("낙찰 후 7일이 경과한 작품에 대해서는 건당 1일 1만원의 보관료(부가세 별도)가 발생합니다.")])]), _c('v-divider', {
    staticClass: "grey-cb my-30 my-md-36"
  }), _c('div', [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("Direct Pickup")])]), _c('ul', {
    staticClass: "letter-list"
  }, [_c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("Our principle : In principle, the successful bidder visits us and picks up the work directly.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("Pickup Deadline: Please pick up works that have been auctioned off within 7 days.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("Prior Reservation: Please make a reservation with us by the day before your visit, and then visit us. Pick-up may not be possible if you visit without prior reservation.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("Pick-up time: Our business hours are 10 am to 6 pm ※ Excluding lunch time (12 am to 1 pm) / Monday to Friday (excluding statutory holidays)")])])])]), _c('div', {
    staticClass: "mt-18 mt-md-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("Shipping Arrangement")])]), _c('ul', {
    staticClass: "letter-list"
  }, [_c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("Shipping Arrangement : If it is difficult for the successful bidder to directly receive the artwork, we can arrange an art transport company under the responsibility and cost of the successful bidder.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("Shipping negotiation: The successful bidder can directly negotiate with the transport company for details such as transport schedule, location, and cost.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("Shipping agency : Because there is a high risk of damage or loss of the artwork, the small general transport company does not arrange for it")])])])]), _c('div', {
    staticClass: "mt-18 mt-md-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("Storage Fee")])]), _c('p', {
    staticClass: "page-text"
  }, [_vm._v("For works that have passed 7 days after the auction ends, a storage fee of KRW 10,000 per day (excluding tax) will be charged.")])])], 1)], 1)], 1)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }